export default "__VITE_ASSET__CxbI9$rg__"